import { useState, useEffect, useCallback } from 'react';

const SCROLL_THRESHOLD = 300; // px from top before button appears

/**
 * Returns `visible` (whether to show the back-to-top button) and
 * `scrollToTop` (handler that smoothly scrolls the window to the top).
 */
export function useScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return { visible, scrollToTop };
}
